/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { AfterViewChecked, ChangeDetectorRef, Component, OnInit, OnDestroy, TemplateRef, ViewChild } from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTabChangeEvent, MatTabGroup } from "@angular/material/tabs";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MatDialog } from "@angular/material/dialog";
import { IgniteBaseComponent, IgniteSnackbarComponent, IgniteSnackbarData, IgniteSnackbarType } from "../../../../libs/ui-common/src";

interface Food {
  value: string;
  viewValue: string;
}

@Component({
  selector: "app-controls",
  templateUrl: "./controls.component.html",
  styleUrls: ["./controls.component.scss"],
})
export class ControlsComponent extends IgniteBaseComponent implements OnInit, AfterViewChecked, OnDestroy {
  @ViewChild("templateBottomSheet") TemplateBottomSheet: TemplateRef<any>;
  @ViewChild("templateBottomSheet2") TemplateBottomSheet2: TemplateRef<any>;
  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;

  progressValue = 0;
  tabStyleSelected = "0";
  tabStyles: Food[] = [
    { value: "0", viewValue: "Button" },
    { value: "1", viewValue: "Menu" },
  ];
  private progressInterval: any;

  constructor(private cdRef: ChangeDetectorRef, private snackBar: MatSnackBar, private bottomSheet: MatBottomSheet) {
    super();
  }

  ngOnInit(): void {
    this.onTabChange();
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  onTabChange($event: MatTabChangeEvent = null): void {
    // Clear existing interval to prevent multiple intervals
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }

    if ($event === null || $event.index === 0) {
      this.progressValue = 0;
      this.progressInterval = setInterval(() => {
        if (this.progressValue >= 100) {
          this.progressValue = 0;
        } else {
          this.progressValue += 2;
        }
      }, 200);
    }
  }

  ngOnDestroy(): void {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }
    super.ngOnDestroy();
  }

  openTemplateSheetMenu(sheet = 1) {
    if (sheet === 1) {
      this.bottomSheet.open(this.TemplateBottomSheet);
    } else {
      this.bottomSheet.open(this.TemplateBottomSheet2);
    }
  }

  closeTemplateSheetMenu() {
    this.bottomSheet.dismiss();
  }

  showSnackbar(type: string): void {
    if (type === "alert") {
      const ref = this.snackBar.openFromComponent(IgniteSnackbarComponent, {
        data: new IgniteSnackbarData("Something went wrong. Try again", IgniteSnackbarType.Alert, "RETRY"),
      });
      ref.onAction().subscribe(() => alert("do retry"));
    }
    if (type === "success") {
      this.snackBar.openFromComponent(IgniteSnackbarComponent, {
        data: new IgniteSnackbarData("Everything is good. Please proceed.", IgniteSnackbarType.Success),
      });
    }
  }
}
